// extracted by mini-css-extract-plugin
export var container = "_1z-0";
export var disabled = "_1z-4";
export var fullWidth = "_1z-3";
export var lined = "_1z-1";
export var selected = "_1z-5";
export var tab = "_1z-2";